module.exports = __webpack_public_path__ + "static/media/sopt12ru.6d3b2eb7.pdf";